import TradePage from "./TradePage";
import { trades } from "@/data/trades";

export default function Roofers() {
  return <TradePage trade={trades.roofers} />;
}
